export default __webpack_public_path__ + "locales/sk/VersionHistory.json?hash=416ddf22beda73b95f1f17bf826cac59";